/**
 * UUID v7 generator (RFC 9562).
 *
 * Layout (128 bits):
 *   48-bit unix_ts_ms | 4-bit version (0b0111) | 12-bit rand_a
 *   2-bit variant (0b10) | 62-bit rand_b
 *
 * Time-sortable: UUIDs generated later sort after earlier ones.
 */

function getRandomBytes(buf: Uint8Array): void {
  // crypto.getRandomValues is available in Node 20+, all modern browsers, and CF Workers
  crypto.getRandomValues(buf as unknown as Uint8Array<ArrayBuffer>);
}

const HEX: string[] = [];
for (let i = 0; i < 256; i++) {
  HEX[i] = (i + 0x100).toString(16).substring(1);
}

function hex(byte: number): string {
  return HEX[byte & 0xff] as string;
}

export function uuidv7(now?: number): string {
  const ms = now ?? Date.now();

  const rand = new Uint8Array(10);
  getRandomBytes(rand);

  const r0 = rand[0] as number;
  const r1 = rand[1] as number;
  const r2 = rand[2] as number;
  const r3 = rand[3] as number;
  const r4 = rand[4] as number;
  const r5 = rand[5] as number;
  const r6 = rand[6] as number;
  const r7 = rand[7] as number;
  const r8 = rand[8] as number;
  const r9 = rand[9] as number;

  const t0 = (ms / 2 ** 32) >>> 0;
  const t1 = ms >>> 0;

  return (
    hex((t0 >>> 8) & 0xff) +
    hex(t0 & 0xff) +
    hex((t1 >>> 24) & 0xff) +
    hex((t1 >>> 16) & 0xff) +
    "-" +
    hex((t1 >>> 8) & 0xff) +
    hex(t1 & 0xff) +
    "-" +
    hex(0x70 | ((r0 >>> 4) & 0x0f)) +
    hex(((r0 << 4) | (r1 >>> 4)) & 0xff) +
    "-" +
    hex(0x80 | (r2 & 0x3f)) +
    hex(r3) +
    "-" +
    hex(r4) +
    hex(r5) +
    hex(r6) +
    hex(r7) +
    hex(r8) +
    hex(r9)
  );
}
